import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ClientStats from "shared/util/ClientStats";
import _str from "shared/util/_str";
import Strf from "shared/components/Strf";
import Masthead from "../Masthead";
import { ROUTES } from "routers/shared/util/consts";

// A-List Bounce 20% off promo.
const Bounce20 = React.forwardRef(({ countdownClock, textTimer }, ref) => {
	useEffect(() => { ClientStats.update("masthead - bounce - discount - shown"); }, []);
	const onClose = () => ClientStats.update("masthead - bounce - discount - closed");

	return (
		<Masthead ref={ref} id="masthead_bounce_discount" className="alistpromo countdown opensans" onClose={onClose}>
			<div ref={countdownClock} className="countdownclock" />
			<div className="text headsubhead">
				<p>
					<span className="head">
						{_str("A-List just isn’t the same without you!")}
					</span>
					<span className="subhead">
						<Strf
							vars={{
								save20PercentOnAList: <strong>{_str("Save 20% on A-List")}</strong>,
								countdownTimer: <span ref={textTimer} className="textcountdown" />,
							}}
						>
							$save20PercentOnAList if you join in the next $countdownTimer!
						</Strf>
					</span>
				</p>
			</div>
			<div className="button">
				<a href={`${ROUTES.Upgrade[0]}?cf=bounce20`} className="flatbutton big">
					{_str("Save 20% on A-List")}
				</a>
			</div>
		</Masthead>
	);
});

Bounce20.propTypes = {
	countdownClock: PropTypes.object.isRequired,
	textTimer: PropTypes.object.isRequired,
};

export default Bounce20;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Promos/Bounce20.jsx